import React, { useState } from "react";
import { Inbox, UserCog, Megaphone, Users, CreditCard } from "lucide-react";
import { useMe } from "../../components/MeContext";
import { DashLayout, StatusBadge } from "../../components/kit";
import { useLoad } from "../../lib/api";
import { VendorIntros } from "./VendorIntros";
import { VendorProfileForm } from "./VendorProfileForm";
import { VendorAds, VendorTeam } from "./VendorAdsTeam";
import { VendorBilling } from "./VendorBilling";

export default function VendorHome() {
  const { me } = useMe();
  const [tab, setTab] = useState("intros");
  const org = useLoad<any>("/vendor/org");
  const isOwner = me?.org_role === "owner";
  return (
    <DashLayout title="Contractor Dashboard" idPrefix="vendor" value={tab} onChange={setTab}
      action={<span className="flex items-center gap-2 text-sm font-semibold">{me?.org?.name} · {me?.org_role}{me?.org && <StatusBadge value={me.org.status} testId="vendor-org-status" />}</span>}
      tabs={[["intros", "My Leads", Inbox], ["profile", "My Profile", UserCog], ["ads", "Sponsored Ads", Megaphone], ["team", "Team & Subscription", Users], ["billing", "Billing", CreditCard]]}>
      {me?.org?.status !== "approved" && (
        <p className="mb-6 rounded border border-[#8a5300] bg-[#fffaf0] p-3 text-sm" data-testid="vendor-pending-notice">This organization is not approved yet, so it does not appear in the directory or in matching.</p>
      )}
      {tab === "intros" && (me?.org?.status === "approved" ? <VendorIntros /> : <p className="card text-sm" data-testid="vendor-leads-inactive">Leads are available only while your organization is approved (current status: {me?.org?.status}).</p>)}
      {tab === "profile" && <VendorProfileForm org={org} isOwner={isOwner} />}
      {tab === "ads" && (me?.org?.status === "suspended" ? <p className="card text-sm" data-testid="vendor-ads-inactive">Ads are unavailable while your organization is suspended.</p> : <VendorAds isOwner={isOwner} />)}
      {tab === "team" && <VendorTeam org={org} isOwner={isOwner} />}
      {tab === "billing" && (me?.org?.status === "suspended" ? <p className="card text-sm" data-testid="vendor-billing-inactive">Billing is unavailable while your organization is suspended.</p> : <VendorBilling />)}
    </DashLayout>
  );
}
